import Vue from 'vue'
import Vuetify from 'vuetify'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
        iconfont: 'fa' || 'md'
  },
  theme: {
    themes: {
      light: {
        primary: '#283593', // deep-purple
      },
    },
  },
})